import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SignDictionary.css';

const LOCAL_SIGNS = [
  { letter: 'A', emoji: '✊', description: 'Fist with thumb resting on side', category: 'alphabet' },
  { letter: 'B', emoji: '🖐', description: 'Flat hand, fingers together, thumb tucked in', category: 'alphabet' },
  { letter: 'C', emoji: '🤏', description: 'Curved hand like holding a ball', category: 'alphabet' },
  { letter: 'D', emoji: '☝️', description: 'Index finger points up, others curve to touch thumb', category: 'alphabet' },
  { letter: 'E', emoji: '✋', description: 'Fingers bent downward, thumb tucked under', category: 'alphabet' },
  { letter: 'F', emoji: '🤌', description: 'Index finger and thumb touching, other fingers up', category: 'alphabet' },
  { letter: 'G', emoji: '👉', description: 'Index finger and thumb pointing sideways', category: 'alphabet' },
  { letter: 'H', emoji: '✌️', description: 'Index and middle fingers pointing sideways together', category: 'alphabet' },
  { letter: 'I', emoji: '🤙', description: 'Pinky finger raised, all others curled', category: 'alphabet' },
  { letter: 'K', emoji: '✌️', description: 'Index and middle fingers up, thumb between them', category: 'alphabet' },
  { letter: 'L', emoji: '👈', description: 'L-shape: index finger up, thumb pointing out', category: 'alphabet' },
  { letter: 'M', emoji: '✊', description: 'Three fingers folded over thumb', category: 'alphabet' },
  { letter: 'N', emoji: '✊', description: 'Two fingers folded over thumb', category: 'alphabet' },
  { letter: 'O', emoji: '👌', description: 'All fingers curved to touch thumb forming O', category: 'alphabet' },
  { letter: 'R', emoji: '🤞', description: 'Index and middle fingers crossed', category: 'alphabet' },
  { letter: 'S', emoji: '✊', description: 'Fist with thumb over fingers', category: 'alphabet' },
  { letter: 'U', emoji: '✌️', description: 'Index and middle fingers pointing up together', category: 'alphabet' },
  { letter: 'V', emoji: '✌️', description: 'Index and middle fingers spread in V shape', category: 'alphabet' },
  { letter: 'W', emoji: '🖖', description: 'Three fingers up: index, middle, ring', category: 'alphabet' },
  { letter: 'Y', emoji: '🤙', description: 'Thumb and pinky extended — hang loose', category: 'alphabet' },
  { letter: '👍 Good', emoji: '👍', description: 'Thumb pointing up — Yes / Good', category: 'expression' },
  { letter: '👎 No', emoji: '👎', description: 'Thumb pointing down — No / Bad', category: 'expression' },
  { letter: '✋ Hello', emoji: '✋', description: 'Open hand, all fingers extended — Hello / Stop', category: 'expression' },
  { letter: '🤟 ILY', emoji: '🤟', description: 'Index, pinky, thumb extended — I Love You', category: 'expression' },
  { letter: '🤘 Rock', emoji: '🤘', description: 'Index and pinky up — Rock On', category: 'expression' },
  { letter: '👌 OK', emoji: '👌', description: 'Index and thumb form circle — OK / Perfect', category: 'expression' },
];

function SignDictionary() {
  const [signs, setSigns] = useState(LOCAL_SIGNS);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get('/api/signs')
      .then(res => { if (res.data && res.data.length > 0) setSigns(res.data); })
      .catch(() => {}); // use local fallback
  }, []);

  const filtered = signs.filter(s => {
    const matchCat = filter === 'all' || s.category === filter;
    const matchSearch = s.letter.toLowerCase().includes(search.toLowerCase()) ||
      s.description.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  return (
    <div className="dictionary">
      <div className="dict-controls">
        <div className="dict-search">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search signs..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="search-input"
          />
        </div>
        <div className="dict-filters">
          {['all', 'alphabet', 'expression'].map(f => (
            <button
              key={f}
              className={`filter-btn ${filter === f ? 'active' : ''}`}
              onClick={() => setFilter(f)}
            >
              {f === 'all' ? 'All Signs' : f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="dict-count">{filtered.length} signs</div>

      <div className="signs-grid">
        {filtered.map((sign, i) => (
          <div key={i} className="sign-card">
            <div className="sign-card-emoji">{sign.emoji || '🤚'}</div>
            <div className="sign-card-letter">{sign.letter}</div>
            <div className="sign-card-desc">{sign.description}</div>
            <div className={`sign-card-cat ${sign.category}`}>{sign.category}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SignDictionary;
